export const getTargetApplicants = (
  budget?: number | null,
  cpa?: number | null,
) => {
  return budget && cpa ? Math.round(budget / cpa) : null;
};

export const getTargetHires = (
  budget?: number | null,
  conversion?: number | null,
  cpa?: number | null,
) => {
  return budget && conversion && cpa
    ? Math.round(((budget / cpa) * conversion) / 100)
    : null;
};
